import React from 'react';
import { Hero } from './components/Hero';
import { Requirements } from './components/Requirements';
import { ValueProposition } from './components/ValueProposition';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Requirements data-id="element-2" />
      <ValueProposition data-id="element-3" />
      <Footer data-id="element-4" />
    </div>;
}